import { render, staticRenderFns } from "./MyLeads.vue?vue&type=template&id=9b675e4c&"
import script from "./MyLeads.vue?vue&type=script&lang=js&"
export * from "./MyLeads.vue?vue&type=script&lang=js&"
import style0 from "./MyLeads.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports